module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "liveStop"
  }, [_c('a', {
    staticClass: "buttom",
    on: {
      "click": function($event) {
        return _vm.backLivePage()
      }
    }
  }, [_vm._v("返回直播页")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9486f75a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/livestop.vue
// module id = 545
// module chunks = 0